export default function codeunitLength(source?: string | null) {
  return (source && source.length) || 0;
}
